/* ======================================================================== */
/* 17. preloader */
/* ======================================================================== */
/* ======================================================================== */
/* preloader */
/* ======================================================================== */
function Preloader() {

	var
		$body = $('body'),
		$pageWrapper = $('.page-wrapper'),
		$preloader = $('.preloader'),
		$curtain = $preloader.find('.preloader__curtain'),
		$logo = $preloader.find('.preloader__logo'),
		$rect = $logo.find('.rect'),
		tl = new TimelineMax();

	function finish() {

		return new Promise(function (resolve) {

			tl
				.clear()
				.to($rect, 1, {
					drawSVG: true,
					ease: Expo.easeInOut
				})
				.to($logo, 0.3, {
					autoAlpha: 0,
				}, '-=0.3')
				.staggerTo($curtain, 1, {
					y: '-100%',
					ease: Expo.easeInOut
				}, 0.05, '-=0.3')
				.set($preloader, {
					autoAlpha: 0
				})
				.add(function () {
					return resolve();
				}, '-=0.6');
		});

	}

	function drawLoading() {

		var lineColor = window.theme.colors.accentPrimary;

		if ($preloader.hasClass('preloader_accent')) {
			lineColor = '#ffffff'
		}

		tl.fromTo($rect, 15, {
			drawSVG: 0,
			stroke: lineColor,
			ease: SlowMo.ease.config(0.7, 0.7, false)
		}, {
			drawSVG: true,
		});

	}

	function animateUnload() {
		window.onbeforeunload = function () {
			$pageWrapper.addClass('page-wrapper_hidden');
			return;
		};
	}

	return new Promise(function (resolve, reject) {

		animateUnload();
		drawLoading();

		$pageWrapper.imagesLoaded().always(load());

		function load() {

			setTimeout(function () {
				$pageWrapper.removeClass('page-wrapper_hidden');
			}, 150);

			if (!$preloader.length) {
				return resolve();
			} else {
				finish().then(function () {
					return resolve();
				});
			}

		}

	});

}
